import { render, staticRenderFns } from "./Seguimientolist.vue?vue&type=template&id=10f16d49&scoped=true"
import script from "./Seguimientolist.vue?vue&type=script&lang=js"
export * from "./Seguimientolist.vue?vue&type=script&lang=js"
import style0 from "./Seguimientolist.vue?vue&type=style&index=0&id=10f16d49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f16d49",
  null
  
)

export default component.exports